<template>
    <TprmModal
        open
        :additional-class-name="className"
        :title="title || ''"
        :allow-close="allowClose"
        :show-close-icon="allowClose"
        @close="$emit('close')"
    >
        <slot />

        <template #footer>
            <slot name="footer">
                <template v-if="progress">
                    <NewButton loading disabled color="primary">
                        {{ loadingLabel || yes }}
                    </NewButton>
                </template>
                <template v-else>
                    <NewButton
                        v-if="no"
                        class="ConfirmationModal__button-no"
                        :color="noColor"
                        :variant="noVariant"
                        @click="$emit('input', false)"
                    >
                        {{ no }}
                    </NewButton>
                    <NewButton
                        :color="yesColor"
                        :variant="yesVariant"
                        :disabled="yesDisabled"
                        class="ConfirmationModal__button-yes"
                        @click="$emit('input', true)"
                    >
                        {{ yes }}
                    </NewButton>
                </template>
            </slot>
        </template>
    </TprmModal>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from '@evidentid/vue-property-decorator';

    import NewButton from '@/components/new-button/NewButton.vue';
    import TprmModal from '@/components/tprm-modal/TprmModal.vue';

    // PRODUCT-26110 QA fixes4: declares every event this component `$emit`s -- without a
    // declared `emits`, Vue 3 warns "Component emitted event 'close'/'input' but it is
    // neither declared in the emits option nor as an 'onClose'/'onInput' prop" every time
    // it fires.
    @Component({
        components: { NewButton, TprmModal },
        emits: [ 'close', 'input' ],
    })
    export default class ConfirmationModal extends Vue {
        @Prop({ type: String, default: 'Yes' })
        private yes!: string;

        @Prop({ type: String, default: 'No' })
        private no!: string;

        @Prop({ type: String, default: 'primary' })
        private yesColor!: string;

        @Prop({ type: String, default: 'fill' })
        private yesVariant!: string;

        @Prop({ type: String, default: 'danger' })
        private noColor!: string;

        @Prop({ type: String, default: 'outline' })
        private noVariant!: string;

        @Prop({ type: Boolean, default: false })
        private destructive!: boolean;

        @Prop({ type: Boolean, default: false })
        private progress!: boolean;

        // For dialogs whose confirmation depends on something still loading, so they can keep the
        // standard footer instead of overriding the slot just to disable one button.
        @Prop({ type: Boolean, default: false })
        private yesDisabled!: boolean;

        @Prop({ type: String, default: null })
        private loadingLabel!: string | null;

        @Prop({ type: String, default: null })
        private size!: string | null;

        @Prop({ type: String, default: 'Are you sure?' })
        private title!: string | null;

        @Prop({ type: String, default: null })
        private additionalClassName!: string | null;

        @Prop({ type: Boolean, default: false })
        private allowClose!: boolean;

        private get className(): string {
            const mainClassName = 'ConfirmationModal';
            const additionalClassName = this.additionalClassName ? ` ${this.additionalClassName}` : '';
            const size = this.size ? ` ${mainClassName}--${this.size}` : '';
            return `${mainClassName}${size}${additionalClassName}`;
        }
    }
</script>
